document.addEventListener("DOMContentLoaded", () => {
  const menuMobileTrigger = document.querySelector(
    "[data-mobile-menu-trigger]"
  );
  const menuMobileContainer = document.querySelector(
    "[data-mobile-menu-container]"
  );
  const submenuMobileTriggers = document.querySelectorAll(
    "[data-submenu-mobile-trigger]"
  );
  const submenuMobilePanels = document.querySelectorAll(
    "[data-submenu-mobile-panel]"
  );

  // Toggle Mobile Menu
  menuMobileTrigger?.addEventListener("click", () => {
    menuMobileContainer?.classList.toggle("is-open");
    menuMobileTrigger.classList.toggle("is-active");
  });

  // Open/Close Submenu Panels
  submenuMobileTriggers?.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      submenuMobilePanels?.forEach((panel) => {
        if (panel.dataset?.panelId === trigger.dataset?.panelId) {
          panel.classList.toggle("open");
        }
      });
    });
  });

  
  //Search
  const mobileSearchTriggers = document.querySelectorAll(
    "[data-mobile-search-trigger]"
  );
  const mobileSearchBar = document.querySelector("[data-mobile-search-bar]");
  const desktopSearchIcon = document.querySelector(
    "[data-desktop-search-trigger]"
  );
  const desktopCloseSearchIcon = document.querySelector(
    "[data-desktop-search-close-trigger]"
  );
  const mainHeaderSearchContainer = document.querySelector(
    "[main-header-search-container]"
  );

  desktopSearchIcon?.addEventListener("click", () => {
    mainHeaderSearchContainer?.classList.toggle("hideScrollableSearch");
    desktopSearchIcon.classList.toggle("open");
  });

  desktopCloseSearchIcon?.addEventListener("click", () => {
    mainHeaderSearchContainer?.classList.add("hideScrollableSearch");
    desktopSearchIcon?.classList.remove("open");
  });
  
  mobileSearchTriggers?.forEach((mobileSearchTrigger) => {
    mobileSearchTrigger.addEventListener("click", () => {
      if(mobileSearchTrigger?.classList.contains('disable-trigger')) return;
      if (mobileSearchBar?.classList.contains("hideMobileSearch")) {
        document.querySelectorAll("input#search")?.forEach(input => input.value = "");
        mobileSearchBar.classList.remove("hideMobileSearch");
        if(menuMobileTrigger) menuMobileTrigger.style.display = "none";
      } else {
        document.querySelectorAll("input#search")?.forEach(input => input.value = "");
        mobileSearchBar?.classList.add("hideMobileSearch");
        if(menuMobileTrigger) menuMobileTrigger.style.display = "block";
      }
    });
  });

  //Welcome Pop Up & Greeting for new customers
  if(window.location.href.includes('new_user')) {
    window.history.pushState('', '', '/');
    const desktopAccountGreet = document.getElementById('desktop-account-greet')
    const mobileAccountGreet = document.getElementById('mobile-account-greet')
    const topHeaderSection = document.getElementById('shopify-section-top-header')
    
    if(desktopAccountGreet) desktopAccountGreet.style.display = 'block';
    
    //Mobile Welcome Pop Up
    if(mobileAccountGreet){
      if(topHeaderSection) topHeaderSection.style.display = 'none';
      mobileAccountGreet.style.display = 'flex';
    setTimeout(() => {
      if(topHeaderSection) topHeaderSection.style.display = 'block';
      mobileAccountGreet.style.display = 'none';
    }, 3000); 
  }
  }
});

